/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum EngagementType {
  FullTimeEmployee = "full_time_employee",
  FullTimeContractor = "full_time_contractor",
  PartTimeEmployee = "part_time_employee",
  Contractor = "contractor",
}

export function instanceOfEngagementType(value: any): boolean {
  for (const key in EngagementType) {
    if (Object.prototype.hasOwnProperty.call(EngagementType, key)) {
      if (EngagementType[key as keyof typeof EngagementType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function EngagementTypeFromJSON(json: any): EngagementType {
  return EngagementTypeFromJSONTyped(json, false);
}

export function EngagementTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EngagementType {
  return json as EngagementType;
}

export function EngagementTypeToJSON(value?: EngagementType | null): any {
  return value as any;
}

export function EngagementTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EngagementType {
  return value as EngagementType;
}
